import { h, ComponentType, ComponentChildren } from "preact";

import classname from "../../../foundation/utils/classname";
import IconLoading from "../Icons/IconLoading";
import IconProps from "../Icons/IconProps";

import styles from "./SplitButton.module.css";

interface Props {
    class?: string;
    mainButtonClass?: string;
    iconButtonClass?: string;
    children?: ComponentChildren;
    icon: ComponentType<IconProps>;
    disabled?: boolean;
    isPending?: boolean;
    mainButtonActivated?: boolean;
    iconButtonActivated?: boolean;
    onClick?: (event: MouseEvent) => void;
    onIconClick?: (event: MouseEvent) => void;
}

function SplitButton({
    class: cssClass,
    mainButtonClass,
    iconButtonClass,
    icon: Icon,
    disabled,
    isPending,
    mainButtonActivated,
    iconButtonActivated,
    children,
    onClick,
    onIconClick
}: Props) {
    const isDisabled = disabled || isPending;

    return (
        <div class={classname(styles.splitButton, cssClass, { [styles.disabled]: isDisabled })}>
            <button
                class={classname("body-1 medium", styles.mainButton, mainButtonClass, {
                    [styles.activated]: mainButtonActivated
                })}
                disabled={isDisabled}
                onClick={onClick}>
                {children}
            </button>
            <div class={styles.splitButtonDivider}/>
            <button
                class={classname(styles.iconButton, iconButtonClass, {
                    [styles.activated]: iconButtonActivated
                })}
                disabled={isDisabled}
                onClick={onIconClick}>
                <Icon/>
            </button>
            {isPending && (
                <div class={styles.pendingContainer}>
                    <IconLoading class="spinning"/>
                </div>
            )}
        </div>
    );
}

export default SplitButton;
